//export const SERVER_URL = "http://127.0.0.1:8000/api/";
//export const FILE_URL = "http://127.0.0.1:8000/storage/";
export const SHARED_DEBT_LINK = "https://debt.clickstore.krd";
export const SERVER_URL = "https://api.clickstore.krd/api/";
export const FILE_URL = "https://api.clickstore.krd/WiseManager/public/storage/";

//export a list of constants
export const CURRENCYS = [{
        cur_id: 1,
        id: 1,
        cur_name: "dinar",
        cur_symbol: "IQD",
        cur_is_main: 1,

    },
    {
        cur_id: 2,
        id: 1,
        cur_name: "dollar",
        cur_symbol: "$",
        cur_is_main: 0,
    },
];